import type { FC } from 'react';
import cn from 'classnames';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import UnderlinedTabs from '@wix/da-ds/pkg/Tabs/dsPresets/UnderlinedTabs';
import { pullDrawingsTabStatus } from '../../../actions/studio/playground';
import { getPlaygroundSubsection } from '../../../selectors/studio';
import { BiData, ContentNavbarClickBiEvent } from '@wix/da-bi/pkg/events';
import { PlaygroundSubsection } from '../../../types/store';
import s from './PlaygroundTabs.scss';

interface Props {
  className?: string;
}

const PlaygroundTabs: FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const activeTab = useSelector(getPlaygroundSubsection);
  const dispatchPullDrawingsTabStatus = useAction(pullDrawingsTabStatus);

  useEffect(() => {
    dispatchPullDrawingsTabStatus();
  }, [dispatchPullDrawingsTabStatus]);

  return (
    <UnderlinedTabs
      className={cn(s['root'], className)}
      uniformTabWidth={isMobile}
      items={[
        {
          label: t('studio.header.tabs.playground.subtabs.dreamup'),
          index: PlaygroundSubsection.DreamUp,
          href: Url.studio({ playground: 'dreamup' }),
          biData: BiData<ContentNavbarClickBiEvent>({
            evid: 120,
            link_name: 'dreamup',
          }),
        },
        {
          label: t('studio.header.tabs.playground.subtabs.draw'),
          index: PlaygroundSubsection.Draw,
          href: Url.studio({
            playground: 'draw',
          }),
          biData: BiData<ContentNavbarClickBiEvent>({
            evid: 120,
            link_name: 'drawings',
          }),
        },
        {
          label: t('studio.header.tabs.playground.subtabs.video'),
          index: PlaygroundSubsection.Video,
          href: Url.studio({
            playground: 'video',
          }),
          biData: BiData<ContentNavbarClickBiEvent>({
            evid: 120,
            link_name: 'video',
          }),
        },
      ]}
      activeIndex={activeTab}
    />
  );
};

PlaygroundTabs.displayName = 'PlaygroundTabs';

export default PlaygroundTabs;
